<template>
    <div class="bk">
        <PullRefresh v-model="isReFresh" @refresh="onRefresh">
            <List
                    style=""
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    loading-text="拼命加载中..."
                    @load="onLoad"
                    :offset="50"
                    :immediate-check="true"
            >
                <SnapshotItem v-for="item in snapshot" :key="item.id" :detail="item"/>
            </List>
        </PullRefresh>
        <!-- <pf code="DEVICE_ADD"> -->
            <Icon name="plus" size="30px" color="#fff" @click="$router.push('/snapshot/add')"
                class="float-btn-add"/>
        <!-- </pf> -->
    </div>
</template>

<script>
    import { PullRefresh, List,Icon } from "vant";
    import {formatSearchData} from "@/utils/format";
    import SnapshotItem from "./components/SnapshotItem"

     export default {
        components: {
            PullRefresh, List,Icon,SnapshotItem
        },
        data() {
            return {
                isReFresh: false,
                loading: false,
                finished: false,
                snapshot: []
            }
        },
        methods:{
            onRefresh() {
                this.isReFresh = true;
                this.snapshot = [];
                this.onLoad(true);
            },
            onLoad(isPullRefresh) {
                const {unitOrOrgan} = this.$default
                const data = {
                    unitId: unitOrOrgan.id,
                    size: 20,
                    page: this.snapshot.length / 20 + 1,
                    currentUnit:true
                }
                formatSearchData(data)
                this.$http.tokiot.snapshot.list(data).then(res => {
                    if (res) {
                        this.snapshot.push(...res.rows);
                        this.loading = false;
                        if (isPullRefresh) this.isReFresh = false;
                        if (this.snapshot.length >= res.total) {
                            this.finished = true;
                        }
                    }
                })
            },
        }
     }
</script>

<style lang="less" scoped>
    .bk {
        width: 100%;
        height: 100%;
        background-color: #EDEDED;
        // position: fixed;
    }
    .float-btn-add {
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        bottom: 28px;
        right: 20px;
        z-index: 999;
        background: #1988fa;
        border-radius: 50%;
        /*box-shadow: 3px 3px 5px rgb(226, 225, 225);*/
    }
</style>